import { HintTypeEnum } from '@nankai/online/constants';

export default {
  seat: {
    parenthesis: '（{{text}}）',
    header: {
      station: '구매 정보를 입력해주세요',
      seat: '좌석을 선택해주세요',
      start: '{{time}} 출발',
      confirm: '좌석 확인',
      bookingConfirm: '※결제 및 예약 완료 후 좌석이 확정됩니다.'
    },
    button: {
      back: '돌아가기',
      next: '다음 단계',
      change: '변경'
    },
    confirmChange: {
      title: '예약이 다음과 같이 변경됩니다.',
      before: '변경 전',
      after: '변경 후',
      label: {
        trainName: '열차',
        date: '날짜',
        time: '시간',
        seat: '좌석',
        seatWithCar: '좌석 ({{carNo}}호차)'
      }
    },
    selectSeatType: {
      title: '좌석 선택 방식',
      auto: '자동 배정',
      manual: '수동 선택'
    },
    station: {
      date: '탑승일',
      startStation: '승차역',
      endStation: '하차역',
      startStationTip: '승차역을 선택해주세요',
      endStationTip: '하차역을 선택해주세요'
    },
    hintType: {
      [HintTypeEnum.OutOfAvailableTerm]:
        '선택한 날짜는 판매 시작 전입니다. (승차일 1개월 전부터 구매 가능합니다.)',
      [HintTypeEnum.EndOfService]:
        '구매 가능한 열차가 없습니다.<br />운행 정보를 확인해 주세요.'
    },
    train: {
      header: '열차를 선택해주세요',
      emptySeat: '빈 좌석',
      trainLabel: '{{trainName}}{{trainServiceNo}}호'
    },
    carriage: {
      carriageCar: '{{carNo}}호차',
      directionUpTitle: '↑ 난바 방면',
      directionDownTitle: '↑ 고야산 방면',
      car1Notice1: '【주의】 2번, 4번, 23번, 27번 좌석에는 창문이 없습니다.',
      car1Notice2:
        ' 승무원실 쪽은 벽으로 되어 있어 전방 풍경을 보실 수 없습니다.'
    },
    wheelchairConfirm: {
      title: '휠체어 좌석을 선택하셨습니다.',
      content:
        '해당 좌석은 휠체어 이용 고객 전용 좌석입니다. 아래 사항을 확인해 주세요.',
      notice1: '휠체어로 방문 예정인 고객만 이용하실 수 있습니다.',
      notice2: '일반 고객의 이용은 삼가 주시기 바랍니다.',
      confirmText: '이대로 선택을 진행하시겠습니까?',
      cancel: '취소',
      confirm: '예'
    }
  },
  error: {
    invalidParams:
      '지정하신 조건에 오류가 있습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    lineIdInvalid:
      '노선이 선택되지 않았습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    productIdInvalid:
      '선택하신 좌석 유형이 올바르지 않습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    forbidden:
      '이 작업은 허용되지 않습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    seatChangeCountExceeded: '좌석 변경 횟수는 2회로 제한됩니다.',
    notFound:
      '찾으시는 페이지를 찾을 수 없습니다. 번거로우시겠지만 처음부터 다시 시도해 주세요',
    system: '시스템 오류가 발생했습니다. 나중에 다시 시도해 주세요'
  }
};
